import { Trans } from "@lingui/macro";
import cx from "classnames";

import { ACCOUNT, usd } from "../terminalMock";

const HEADING = "t-display mb-9 text-[17px] uppercase tracking-[1.4px] opacity-90";
const ROW = "flex justify-between text-[13.5px]";

type Props = {
  className?: string;
  style?: React.CSSProperties;
};

export function AccountPanel({ className, style }: Props) {
  const actions = [<Trans key="d">Deposit</Trans>, <Trans key="w">Withdraw</Trans>, <Trans key="t">Transfer</Trans>];

  return (
    <section
      className={cx("t-anim-scale-3 rounded-10 p-16 text-white", className)}
      style={{ background: "var(--t-acct)", boxShadow: "var(--t-shadow)", ...style }}
    >
      <div className="mb-16 grid grid-cols-3 gap-8">
        {actions.map((label, index) => (
          <button
            key={index}
            type="button"
            className="t-glass t-glass-hover rounded-full py-9 text-[12.5px] font-semibold transition-[background,transform] duration-200"
          >
            {label}
          </button>
        ))}
      </div>

      <div className={HEADING}>
        <Trans>Account Equity</Trans>
      </div>
      <div className="mb-16 flex flex-col gap-7">
        <div className={ROW}>
          <span className="opacity-80">
            <Trans>Spot</Trans>
          </span>
          <span className="t-nums font-semibold">{usd(ACCOUNT.spotEquity)}</span>
        </div>
        <div className={ROW}>
          <span className="opacity-80">
            <Trans>USDX</Trans>
          </span>
          <span className="t-nums font-semibold">{usd(ACCOUNT.usdxEquity)}</span>
        </div>
      </div>

      <div className={HEADING}>
        <Trans>USDX Overview</Trans>
      </div>
      <div className="flex flex-col gap-7">
        <div className={ROW}>
          <span className="opacity-80">
            <Trans>Balance</Trans>
          </span>
          <span className="t-nums font-semibold">{usd(ACCOUNT.usdxEquity)}</span>
        </div>
        <div className={ROW}>
          <span className="opacity-80">
            <Trans>Unrealized PNL</Trans>
          </span>
          <span className="t-nums font-bold" style={{ color: "var(--t-acct-pnl)" }}>
            +{usd(ACCOUNT.unrealizedPnl)}
          </span>
        </div>
        <div className={ROW}>
          <span className="opacity-80">
            <Trans>Margin usage</Trans>
          </span>
          <span className="t-nums font-semibold">{ACCOUNT.marginUsage}%</span>
        </div>
      </div>

      <div className="mt-12 h-6 overflow-hidden rounded-full bg-white/25">
        <div
          className="t-anim-equity h-full rounded-full bg-white"
          style={{ width: `${ACCOUNT.marginUsage}%` }}
        />
      </div>
    </section>
  );
}
